import CardsModule from './cards-module/cards-module';
export default CardsModule;
//# sourceMappingURL=index.js.map